import styled from '../../../../theme/styled-with-theme';
import { mediaQueries } from '../../../../styles/media-queries';

import { Column } from '../../../Layout';
import Link from '../../../Link';

export const NavListColumn = styled(Column)`
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const FooterNavItemList = styled('ul')<{ columnCount: number }>`
  list-style-type: none;
  margin: 0;
  padding: 0;
  column-count: ${({ columnCount }) => (columnCount > 3 ? 2 : 1)};

  li {
    break-inside: avoid-column;
  }

  ${mediaQueries.desktop} {
    column-count: 1;
  }
`;

export const FooterNavItem = styled('li')`
  margin-bottom: ${({ theme }) => theme.spacing.sm};

  ${mediaQueries.desktop} {
    margin-bottom: ${({ theme }) => theme.spacing.m};
  }
`;

export const FooterLink = styled(Link)`
  ${({ theme }) => ({
    color: theme.color.footerTextSupplementary,
    fontSize: `${theme.fontSize.s}`,
    lineHeight: theme.lineHeight.s
  })}
  font-weight: ${({ theme }) => theme.fontWeight[400]};
  text-decoration: none;
  transition: 0.2s color ease;

  &:hover {
    color: ${({ theme }) => theme.color.inlineAnchorHover};
    text-decoration: underline;
  }
`;
